const authOptions = {
  strategies: {
    local: {
      endpoints: {
        login: {
          url: "/api/v1/auth/obtain/",
          method: "post",
          propertyName: "access"
        },
        user: {
          url: "/api/v1/users/me/",
          method: "get",
          propertyName: false
        },
        logout: false
      },
      tokenType: "Bearer"
    },
    realHrSoft: {
      _scheme: "oidc",
      issuer: "https://merojob.realhrsoft.com/o",
      client_id: "X9Z26imtXvpfjFRQu214Rt65UhR4Mb6JXA9f04Pz",
      // issuer: "https://demo.realhrsoft.com/o",
      // client_id: "4rZ3Pq87xRAZUD9f70STMwLmbxZ78pHk56zxS3YU",
      token_key: "id_token",
      scope: ["openid", "profile", "application_groups"],
      callback: "/oidc/authorize/callback/",
      userinfo_endpoint: "/api/v1/users/me/"
    },
    google: {
      _scheme: "oidc",
      issuer: "https://accounts.google.com",
      client_id:
        "734965342250-0evepiepn69sqsoiruo0834uq85nk8pq.apps.googleusercontent.com",
      token_key: "id_token"
    }
  },
  redirect: {
    login: "/account/login/",
    logout: "/account/login/",
    callback: "/oidc/authorize/callback/",
    home: "/"
  },
  rewriteRedirects: false,
  fullPathRedirect: false,
  autoLoginOIDCStrategy: "realHrSoft"
};

export default authOptions;
